export default __webpack_public_path__ + "media/images/main/logo-81cb28e977c8278389dc3e0a3f7b6d7e.png";